import api from "../../api/index";

const updatepassword = `${process.env.VUE_APP_BASE_URI}/auth/user/password`;

const getDefaultState = () => {
  return {
    status: "",
  };
};

const state = getDefaultState();

const actions = {
  async updatePassword({ commit }, updatedpassword) {
    commit("updatepassword_request");
    const res = await api.patch(updatepassword, updatedpassword);
    if (res.data.status === "success") {
      commit("updatepassword_success");
    }
    return res;
  },

  async resetProfileState({ commit }) {
    await commit("resetprofilestate_success");
  },
};

const mutations = {
  updatepassword_request: (state) => (state.status = "loading"),
  updatepassword_success: (state) => (state.status = "success"),
  resetprofilestate_success: (state) => Object.assign(state, getDefaultState()),
};

export default {
  state,
  actions,
  mutations,
};
